import useLocalStorage from '@/hooks/useLocalStorage'
import { useCurrentAccountContext } from '@/components/accounts/CurrentAccountProvider'

export default function useRecentDocumentIds() {
  const { rootOrganization } = useCurrentAccountContext()

  return useLocalStorage<string[]>(
    `recent-documents-${rootOrganization.id}`,
    [] as string[],
  )
}
